import { useIsClusterDemoMode } from '@cast/infrastructure-demo';
import { useAbility } from '@cast/shared-ability-data-access';
import { useTimeRangeSelection } from 'hooks/useTimeRangeSelection';
import {
  DateRangeFilter,
  RangePickerQueryParamKeys,
} from '@cast/shared-date-ui';

export const QUERY_PARAM_KEYS: RangePickerQueryParamKeys = {
  fromDate: 'cost_report_from',
  toDate: 'cost_report_to',
  dateRangePreset: 'cost_report_date_preset',
  timeZone: 'cost_report_timezone',
};

export const useCostReportTimeRangeSelection = () => {
  const displayShortRangePresets = useAbility().can(
    'view',
    'FeatureClusterCostMonitoringShortDateRange'
  );
  const isClusterDemoMode = useIsClusterDemoMode();

  return useTimeRangeSelection({
    queryParamKeys: QUERY_PARAM_KEYS,
    initialState: {
      preset: displayShortRangePresets
        ? DateRangeFilter.Today
        : DateRangeFilter.ThisMonth,
      timeZone: isClusterDemoMode ? 'UTC' : undefined,
    },
  });
};
